import { WSPillProps } from "@wingspanhq/fe-component-library";
import { BatchSummaryExpand } from "@wingspanhq/wingspan-api-sdk";
import { queriesBatches } from "@query";

import { selectorImportBatchStatusPill } from "../selectors/selectorImportBatchStatusPill";
import { selectorImportBatchStatusSecondaryText } from "../selectors/selectorImportBatchStatusSecondaryText";
import { useFlatfileUploadJobStatus } from "./useFlatfileUploadJobStatus";

/**
 * Status pill and sub-label for an import batch, resolved from the batch, its
 * row counts and the Flatfile upload job.
 *
 * Takes a batch id rather than a batch so list cells can use it too; both reads
 * come out of the React Query cache the detail page already filled.
 */
export function useImportBatchStatus(
  batchId: string,
  showIcon?: boolean
): { pill: WSPillProps; secondaryText?: string } {
  const queryBatch = queriesBatches.getBatch.useQuery(
    { batchId },
    { enabled: !!batchId }
  );
  const querySummary = queriesBatches.getBatchSummary.useQuery(
    { batchId, expand: [BatchSummaryExpand.BREAKDOWN] },
    { enabled: !!batchId }
  );

  const batch = queryBatch.data;
  const { isFailed: isUploadFailed } = useFlatfileUploadJobStatus(batch);

  if (!batch) {
    return {
      pill: {
        theme: "neutral",
        text: showIcon ? "" : "--",
        ...(showIcon ? { icon: "loader" as const } : {})
      }
    };
  }

  return {
    pill: selectorImportBatchStatusPill({
      batch,
      itemCount: querySummary.data?.progress?.total,
      failedCount: querySummary.data?.progress?.failed,
      isUploadFailed,
      isLoading: queryBatch.isLoading || querySummary.isLoading,
      showIcon
    }),
    secondaryText: selectorImportBatchStatusSecondaryText({
      batch,
      itemCount: querySummary.data?.progress?.total
    })
  };
}
